import HeroBg from "public/emulateSimulate/hero-section-background.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Choose the best testing approach for your needs",
    link: "contact-us",
  },
  title: "Real-World IT Testing: Emulation vs. Simulation",
  desc: "Understand the key differences between network emulation and simulation to optimize your IT testing strategy.",
  image: HeroBg,
};
